module.exports = __webpack_public_path__ + "officialStatic/img/jdfLogo.e581aba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/jdfLogo.png
// module id = aWvD
// module chunks = 0